import { render, staticRenderFns } from "./CargoStatusORTHouse.vue?vue&type=template&id=458a1b2e&"
import script from "./CargoStatusORTHouse.vue?vue&type=script&lang=js&"
export * from "./CargoStatusORTHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports